import { useTypedFlags } from "@hooks/useTypedFlags";
import { useIsFirmMemberOrStandaloneUser } from "@hooks/useIsFirmMemberOrStandaloneUser";

/**
 * The "Updated through" filter and "via MCP" suffix are hidden from clients:
 * users of a firm-managed workspace who are not members of that firm. Firm
 * members and standalone business owners see them when the flag is on.
 */
export function useIsChannelAttributionEnabled(): boolean {
    const { activityUpdatedThroughFilter: isFlagOn } = useTypedFlags();
    const isFirmMemberOrStandaloneUser = useIsFirmMemberOrStandaloneUser();
    return isFlagOn && isFirmMemberOrStandaloneUser;
}
